import { useState } from 'react'
import { SearchableSelect } from '../SearchableSelect/SearchableSelect'
import type { ListFilterValues } from '../../types'
import type { ListFilterBarProps } from './ListFilterBar.types'
import '../ConfigFilterBar/ConfigFilterBar.css'

export function ListFilterBar({
  fields,
  initialValues,
  onChange,
}: ListFilterBarProps) {
  const [values, setValues] = useState<ListFilterValues>(initialValues)
  const [isExpanded, setIsExpanded] = useState(
    fields.some((field) => Boolean(initialValues[field.key]))
  )
  const hasActiveFilter = fields.some((field) =>
    Boolean(values[field.key]?.trim())
  )
  const emptyValues: ListFilterValues = Object.fromEntries(
    fields.map((field) => [field.key, ''])
  )

  function removeAllFilters() {
    setValues(emptyValues)
    onChange(emptyValues)
  }

  return (
    <div className="config-filter-bar">
      <button
        type="button"
        className="config-filter-bar-toggle"
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? '-' : '+'} Filters
      </button>

      {isExpanded && (
        <div className="config-filter-bar-body">
          {fields.map((field) => {
            const inputId = `list-filter-${field.key}`
            const value = values[field.key] ?? ''
            return (
              <div key={field.key} className="config-filter-bar-column">
                <label
                  className="config-filter-bar-column-label"
                  htmlFor={inputId}
                >
                  {field.label}
                </label>
                {field.kind === 'text' ? (
                  <input
                    id={inputId}
                    type="text"
                    className="form-control form-control-sm config-filter-bar-column-input"
                    placeholder={field.placeholder}
                    value={value}
                    onChange={(e) =>
                      setValues({ ...values, [field.key]: e.target.value })
                    }
                  />
                ) : (
                  <SearchableSelect
                    id={inputId}
                    className="config-filter-bar-column-input"
                    ariaLabel={field.label}
                    placeholder="All"
                    value={value}
                    options={field.options}
                    searchMode={field.searchMode}
                    onChange={(next) =>
                      setValues({ ...values, [field.key]: next })
                    }
                  />
                )}
              </div>
            )
          })}

          <div className="config-filter-bar-footer">
            {hasActiveFilter && (
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={removeAllFilters}
              >
                Remove filters
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => onChange(values)}
            >
              Filter
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
